import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDiscover = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M12.279 4C7.724 4 4 7.724 4 12.279s3.724 8.279 8.279 8.279 8.279-3.724 8.279-8.28c0-4.554-3.724-8.278-8.28-8.278ZM5.7 12.279C5.7 8.662 8.662 5.7 12.279 5.7c3.616 0 6.579 2.962 6.579 6.579 0 3.616-2.963 6.579-6.58 6.579-3.616 0-6.578-2.963-6.578-6.58Zm7.693-3.822a4.948 4.948 0 0 0-4.936 4.936 2.713 2.713 0 0 0 2.707 2.707c2.713 0 4.936-2.223 4.936-4.936a2.717 2.717 0 0 0-2.707-2.707Zm-3.236 4.936a3.248 3.248 0 0 1 3.236-3.236c.548 0 1.007.46 1.007 1.008a3.253 3.253 0 0 1-3.236 3.235 1.013 1.013 0 0 1-1.007-1.007Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDiscover;
